<div class="row">
    <div class="col-12 text-center" *ngIf="isLoading">
        <h3>{{ loadingMessage }}</h3>
    </div>
    <div class="col-12 text-danger p-2" *ngIf="powerBiError">
        {{ powerBiError }}
    </div>
    <div class="col-12" *ngIf="!powerBiError">
        <div
            #powerBiContainer
            style="height: 900px; width: 100%;">
        </div>
    </div>
</div>
